import styled from 'styled-components';

export const ContainerGoogle = styled.div`
    width: 100%;

    img {
       border-radius: 50%; 
       width: 30%;
    }
`;

export const DivButtonsGoogle = styled.div`
    display: flex;
    margin-top: 18px;

    @media (max-width: 600px){
        display: inline;   
    }

`;